import { useAppDispatch } from '../../../store/hooks';
import { DrawerCommon } from '../../Shared/Drawer/DrawerCommon';
import EditCalendarEvent from './EditCalendarEvent/EditCalendarEvent';

export default function DrawerEditCalendarEvent() {
    const dispatch = useAppDispatch();

    // const drawerOpen = useAppSelector(state => {
    //     return state.calendar?.editEventDrawerOpen || false;
    // }, shallowEqual);

    const handleHideCloseDrawer = () => {}; //dispatch(calendarActions.closeDrawerEditCalendarEvent());

    return (
        <DrawerCommon
            open={false}
            handleOnClose={handleHideCloseDrawer}
            title="Schedule Calendar Event"
        >
            <EditCalendarEvent onCloseHandler={handleHideCloseDrawer} />
        </DrawerCommon>
    );
}
